export const IS_HORIZONTAL_FILTER_ENABLED = false;
